import { createSelector } from 'reselect';

const getUser = (state) => state.user;

export const getCurrentUser = createSelector(
    [getUser],
    (user) => user.currentUser
);

export const getError = createSelector([getUser], (user) => user.error);

export const getToken = createSelector([getUser], (user) => user.token);

export const getRoles = createSelector([getUser], (user) => user.rS);

export const getFetching = createSelector(
    [getUser],
    (user) => user.fetching
);